/**
 * Detect whether an event was produced by a Bedrock inference rule (as opposed
 * to a deterministic Lambda handler).
 *
 * Signal priority:
 *   1. metadata.source contains "bedrock" — reliable when the router writes
 *      the source ARN, but at the moment output events written via
 *      write_output_event get source = data-plane Lambda ARN.
 *   2. data.analysis field present — every Bedrock outputSchema in the demo
 *      includes an `analysis` field; no deterministic handler emits one.
 *   3. data.confidence + data.recommendedAction — belt-and-braces for future
 *      Bedrock rules that might omit `analysis` for some reason.
 */
export function isBedrockEvent(item: {
  metadata?: { source?: string; [k: string]: unknown };
  data?: unknown;
}): boolean {
  const source = String(item?.metadata?.source || '').toLowerCase();
  if (source.includes('bedrock')) return true;
  const d = item?.data as Record<string, unknown> | undefined;
  if (!d || typeof d !== 'object') return false;
  if (typeof d.analysis === 'string' && d.analysis.length > 0) return true;
  if (typeof d.confidence === 'number' && typeof d.recommendedAction === 'string') return true;
  return false;
}
